import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

//css
import { Button, Table } from "react-bootstrap";
import buttonStyles from "../../styles/Buttons.module.css";

//pages
import AddUsers from "./AddUsers.js";
import { Loading, AppPagination } from "../components/Index.js";
import EditUsers from "./EditUsers.js";
import { UsersService } from "../../services/Users.js";
import AppNav from "../../header/AppNav.js";
import AlertModal from "../../components/AlertModal";

function Users(props) {
  const [addModalShow, setAddModalShow] = useState(false);
  const [editModalShow, setEditModalShow] = React.useState(props.id);
  const [loading, setLoading] = useState(false);
  const [paginations, setPaginations] = useState({
    cur: 1,
    max: 50,
  });

  // Modal states
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertModalData, setAlertModalData] = useState({ title: '', message: '', type: 'info' });

  const [user, setUser] = useState([]);
  const getUser = async (page = 1) => {
    setLoading(true);
    try {
      const res = await UsersService.getAllUsers(page);
      // console.log(res.data);
      if (res.data?.length > 0) {
        setUser(res.data);
        setPaginations({
          cur: res.pagination_data.page,
          max: res.pagination_data.pages,
        });
      } else {
        setUser([]);
        setPaginations({
          cur: 1,
          max: 1,
        });
      }
      setLoading(false);
    } catch (error) {
      setAlertModalData({
        title: 'Error',
        message: error.message || 'Failed to load users',
        type: 'error'
      });
      setShowAlertModal(true);
      setLoading(false);
      setPaginations({
        cur: 1,
        max: 1,
      });
    }
  };

  const changePage = (page) => {
    getUser(page);
  };

  useEffect(() => {
    getUser();
  }, []);

  const getDesignationInfo = (user) => {
    const designation = user.designationDetails?.designation || "";
    let location = "";
  
    if (user.talukDetails) {
      location = user.talukDetails.taluk;
    } else if (user.phcDetails) {
      location = user.phcDetails.phc;
    } else if (user.ashaBlockDetails) {
      location = user.ashaBlockDetails.ashaBlock;
    }
  
    return { designation, location };
  };
  return (
    <div>
      <AppNav />
      <h1 className="list-style">Users</h1>
      <div className="list-table-style">
        <div className="add-button">
          <Button 
            variant="primary" 
            onClick={() => setAddModalShow(true)}
            className={buttonStyles.primaryButton}
          >
            Add Users
          </Button>
          <AddUsers
            show={addModalShow}
            onHide={() => setAddModalShow(false)}
            onClose={() => getUser()}
          />
        </div>
        <Table striped bordered hover className="professional-table">
          <thead>
            <tr>
              <th>Sl No</th>
              <th className="list-item-align-center">Name</th>
              <th className="list-item-align-center">Mob no</th>
              <th className="list-item-align-center">Email</th>
              <th className="list-item-align-center">Role</th>
              <th className="list-item-align-center">Designation</th>
              <th className="list-item-align-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {!loading &&
              user.map((i, index) => (
                <tr key={i.id}>
                  <td>{index + 1}</td>
                  <td className="list-item-align-center">{i.name}</td>
                  <td className="list-item-align-center">{i.mobileNo}</td>
                  <td className="list-item-align-center">{i.email}</td>
                  <td className="list-item-align-center">{i.roleDetails.role}</td>
                  <td className="list-item-align-center">
  <div>
    <div>{getDesignationInfo(i).designation}</div>
    {getDesignationInfo(i).location && (
      <div className="text-muted small">{getDesignationInfo(i).location}</div>
    )}
  </div>
</td>
                  <td className="list-item-align-center">
                    <EditUsers user={i} onClose={() => getUser()} />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
      <div className="d-flex justify-content-center my-3">
        <AppPagination
          curPage={paginations.cur}
          maxPage={paginations.max}
          changePage={changePage}
        />
      </div>

{/* Alert Modal */}
      <AlertModal
        show={showAlertModal}
        title={alertModalData.title}
        message={alertModalData.message}
        type={alertModalData.type}
        onClose={() => setShowAlertModal(false)}
      />
    </div>
  );
}

export default Users;
